import React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

const WorkerReportIcon = ({ isOpen = false }) => (
  <SvgIcon
    viewBox="0 0 40 28"
    fill="none"
    sx={{
      width: 40,
      height: 28,
      borderRadius: '4px',
    }}
  >
    <path
      d="M13.3333 20.6668H16.6666V7.3335H13.3333V20.6668ZM8.33325 20.6668H11.6666V14.0002H8.33325V20.6668ZM18.3333 11.5002V20.6668H21.6666V11.5002H18.3333Z"
      fill="#7A23FF"
    />
    <path
      d="M28 12.5L31 15.5L34 12.5"
      stroke="#7A23FF"
      strokeWidth="1.5"
      fill="none"
      transform={isOpen ? 'rotate(180 31 14)' : undefined}
    />
  </SvgIcon>
);

WorkerReportIcon.propTypes = {
  isOpen: PropTypes.bool,
};

export default WorkerReportIcon;
